import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ConfirmMergeOrgModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ConfirmMergeOrgModal" */
      './ConfirmMergeOrgModal'
    ),
  loading: LoadingModal,
});
